<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section style="margin-top:140px">
        <div class="container">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link to="/">Home</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link to="/solutions/cloud">Cloud</router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                Overview
              </li>
            </ol>
          </nav>

          <div class="row">
            <div class="col-lg-8">
              <h2 class="title">Cloud</h2>
              <p class="lead">
                IT leaders are always under increasing pressure to transform
                from cost generating centers into strategic service providers
                and business enablers for their organizations. This
                transformation is made possible by Cloud technologies bringing
                in a new flexible and efficient method of running IT Businesses
                other than the Traditional methods. With our cloud Technologies,
                organizations can scale up efficiently, allowing them to
                introduce new products as a result of ever-changing demand in
                application use.
              </p>
              <p class="lead">
                Enjoy our cloud unprecedented advantages in terms of scale,
                flexibility, cost efficiency and security. With over 50 Amazon
                Web and Azure certified team members and more than 200 technical
                certifications, Our company offers a deep bench of experts who
                have confidently handled many complex cloud projects.
              </p>

              <H3>Expertise</H3>
              <p class="lead">
                Get help and innovative solutions from engineers, developers and
                architects certified from top cloud companies.
              </p>

              <H3>Simplicity</H3>
              <p class="lead">
                Get all of our cloud benefits that will give you unique user
                experience..
              </p>
              <H3>Optimization</H3>
              <p class="lead">
                Optimization- get your data resources optimized with automation,
                data analytics and machine learning.
              </p>
              <p class="lead">
                Our cloud solutions also include consulting, design, migration,
                integration, managed services, and support through the following
                solutions:
              </p>
              <ul>
                  <li class="h4">
              <router-link to="/solutions/cloud/datacentermodernization">Data Center Mondernization</router-link></li>
               <li class="h4"> <router-link to="/solutions/cloud/hybridclouds">Hybrid Clouds</router-link></li>
              <li class="h4">  <router-link to="/solutions/cloud/devops">DevOps</router-link></li>
              </ul>
            </div>

            <div class="col-lg-4">
              <CloudSideNav></CloudSideNav>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import CloudSideNav from "./CloudSideNav";
export default {
  name: "cloud overview",
  components: {
    CloudSideNav,
  },
};
</script>
<style>
.shape-container {
  padding-bottom: 5rem;
}
</style>
